import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { PurchaseOrders_ModuleContextService } from './PurchaseOrders.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class PurchaseOrders_orderline_total_received_widget_ComponentContextService {
  private readonly moduleContext: PurchaseOrders_ModuleContextService;

  constructor(moduleContext: PurchaseOrders_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'orderline_total_received_widget',
      type: ComponentType.widget
    }
  }
}